module.exports = __webpack_public_path__ + "static/media/Booking-03.3f5188da.png";